module.exports = __webpack_public_path__ + "img/vedomosti-logo-white.ede38024.svg";